var React = require('react');

function Circle1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1213","data-name":"Path 1213","d":"M2678.384-14692.371s41.495.929,52.591,44.052-36.053,50.662-43.414,51.029-56.307,6.122-54.519-43.081S2678.384-14692.371,2678.384-14692.371Z","transform":"translate(14692.871 2733.198) rotate(-90)","fill":"none","stroke":"#fff","strokeWidth":"1"}));
}

Circle1.defaultProps = {"width":"96.419","height":"100.706","viewBox":"0 0 96.419 100.706"};

module.exports = Circle1;

Circle1.default = Circle1;
